import React, { useState } from "react";
import {
  Card,
  Table,
  Button,
  Dropdown,
  Form,
  Pagination,
} from "react-bootstrap";
import {
  FaPlus,
  FaFilter,
  FaRedo,
  FaTrashAlt,
  FaEdit,
  FaEye,
} from "react-icons/fa";

const LibraryEbooksTable = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([
    {
      name: "Ebook One",
      category: "Technology",
      author: "Author X",
      publication: "Publisher X",
      available: "Yes",
      status: "Active",
    },
    {
      name: "Ebook Two",
      category: "Science",
      author: "Author Y",
      publication: "Publisher Y",
      available: "No",
      status: "Inactive",
    },
  ]);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleDelete = (index) => {
    const newData = [...data];
    newData.splice(index, 1);
    setData(newData);
  };

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="p-3">
      <h4>Library Ebooks</h4>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Button variant="primary" className="d-flex align-items-center">
          <FaPlus className="me-2" /> + Add Ebook
        </Button>
        <div className="d-flex align-items-center">
          <div className="position-relative me-2" style={{ width: "300px" }}>
            <Form.Control
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
              style={{ borderRadius: "20px", paddingLeft: "35px" }}
            />
            <FaFilter
              style={{
                position: "absolute",
                left: "10px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          </div>
          <Button variant="light" className="me-2">
            <FaFilter />
          </Button>
          <Button variant="light" className="me-2">
            <FaRedo />
          </Button>
        </div>
      </div>
      <Card>
        <Card.Body>
          <div  >
            <Table
              striped
              bordered
              hover
              // responsive
              style={{ overflow: "auto" }}
            >
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Author</th>
                  <th>Publication</th>
                  <th>Available</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.category}</td>
                    <td>{item.author}</td>
                    <td>{item.publication}</td>
                    <td>{item.available}</td>
                    <td>{item.status}</td>
                    <td className="text-center">
                      <Dropdown
                        className={`dropdown ${
                          filteredData.length === 1 ? "dropend" : ""
                        }`}
                      >
                        <Dropdown.Toggle
                          variant="light"
                          size="sm"
                          className="border-0"
                        >
                          Actions
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                          <Dropdown.Item>
                            <FaEye className="me-2 text-info" /> View
                          </Dropdown.Item>
                          <Dropdown.Item>
                            <FaEdit className="me-2 text-primary" /> Edit
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => handleDelete(index)}>
                            <FaTrashAlt className="me-2 text-danger" /> Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
                {!filteredData.length && (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No results found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <span>
              Showing {filteredData.length} of {data.length} entries
            </span>
            <Pagination>
              <Pagination.Prev />
              <Pagination.Item active>1</Pagination.Item>
              <Pagination.Item>2</Pagination.Item>
              <Pagination.Next />
            </Pagination>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default LibraryEbooksTable;
